const getSort = (sort) => {
  if (!Object.keys(sort)[0]) return;
  return {
    by: Object.keys(sort)[0],
    order: sort[Object.keys(sort)[0]] === 'ascend' ? 'asc' : 'desc',
  };
};

export default getSort;
